/**
 * Branded hero illustration: a stylised smartwatch showing the assistant, drawn
 * as inline SVG so it scales crisply and ships no image bytes. Decorative — the
 * heading and copy carry the meaning — so it is hidden from assistive tech.
 * Replace with a real device screenshot at launch via the Screenshots section.
 */
export default function WatchMockup({ className = '' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 240 300"
      className={className}
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      {/* Watch bands */}
      <rect x="86" y="6" width="68" height="70" rx="20" fill="#0f172a" />
      <rect x="86" y="224" width="68" height="70" rx="20" fill="#0f172a" />
      {/* Watch case */}
      <rect x="46" y="56" width="148" height="188" rx="46" fill="#020617" stroke="#1e293b" strokeWidth="2" />
      {/* Crown */}
      <rect x="192" y="132" width="8" height="36" rx="4" fill="#334155" />
      {/* Screen */}
      <rect x="64" y="74" width="112" height="152" rx="34" fill="#0b1220" />
      {/* Assistant reply bubble */}
      <rect x="80" y="96" width="80" height="30" rx="12" fill="#10b981" />
      <circle cx="94" cy="111" r="4" fill="#022c22" />
      <circle cx="108" cy="111" r="4" fill="#022c22" />
      <circle cx="122" cy="111" r="4" fill="#022c22" />
      {/* User line */}
      <rect x="96" y="138" width="64" height="10" rx="5" fill="#1e293b" />
      <rect x="112" y="156" width="48" height="10" rx="5" fill="#1e293b" />
      {/* Mic button */}
      <circle cx="120" cy="196" r="20" fill="#10b981" />
      <rect x="114" y="182" width="12" height="20" rx="6" fill="#022c22" />
      <path d="M110 198a10 10 0 0 0 20 0" fill="none" stroke="#022c22" strokeWidth="3" strokeLinecap="round" />
      <line x1="120" y1="208" x2="120" y2="214" stroke="#022c22" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
